import React, { useEffect, useState, useMemo } from 'react';
import { AddContainer, Component4, PatientViewContainer, Texts, Text, Switch, InnerComponent, Component5, HeaderPart, FooterPart, SaveButton, CancelButton } from './Style';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import { palette, shadows } from 'src/config/theme.js';
import { alpha } from '@mui/material';
import SwitchComponent from 'src/components/shared/Form/Switch';
import InputSelect from 'src/components/shared/Form/Select';
import theme from 'src/config/theme.js';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { useDispatch, useSelector } from 'react-redux';
import { getClinicProfileByIdRequest, getTemplateByClinicIdRequest, postMedicalRecordsRequest, postTemplateRequest } from 'src/modules/app/store/appActions';
import { useParams } from 'react-router-dom';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import useAppointmentDetails from '../../UseAppointmentDetails';
import dayjs from 'dayjs';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive';



const validationSchema = Yup.object().shape({
    diagnosis: Yup.string().required('diagnosis is required'),
    notes: Yup.string().required('prescription are required'),
    title: Yup.string().when('isTemplateSaved', {
        is: true,
        then: (schema) => schema.required('new template name is required'),
    })

})
function PrescriptionTabForm({ onClose, fetchPrescription }) {
    const { isMobile, isTablet, isDesktop } = useResponsive();

    const [selectValue, setSelectValue] = useState('');
    const [isTemplateSaved, setIsTemplateSaved] = useState(false);

    const dispatch = useDispatch();
    const TemplateData = useSelector((state) => state.app.getTemplateByClinicId);
    const ClinicProfileData = useSelector((state) => state.app.getClinicProfileById);


    const { PatientId, user, clinicId, appointmentId } = useAppointmentDetails();
    console.log("here is clinic id in prescription form", clinicId)


    useEffect(() => {
        if (clinicId) {
            dispatch(getTemplateByClinicIdRequest(clinicId));
            dispatch(getClinicProfileByIdRequest(clinicId));
        }
    }, [clinicId, dispatch]);

    const allTemplates = useMemo(() => {
        const getTemplates = (obj) => {
            if (Array.isArray(obj)) return obj;
            if (obj?.payload?.data && Array.isArray(obj.payload.data)) return obj.payload.data;
            if (obj?.data && Array.isArray(obj.data)) return obj.data;
            if (obj?.payload && Array.isArray(obj.payload)) return obj.payload;
            return [];
        };

        const templatesArray = getTemplates(TemplateData);

        const profile = ClinicProfileData?.payload?.data || ClinicProfileData?.data || ClinicProfileData;
        
        // IMPORTANT: Verify this profile belongs to the CURRENT clinic
        // Check multiple possible ID locations
        const profileId = profile?._id || profile?.id || 
                         (Array.isArray(profile) ? (profile[0]?._id || profile[0]?.id) : null) ||
                         profile?.profile?._id || profile?.profile?.id;
        
        let clinicProfileTemplates = [];
        
        // Debug logging to help identify why templates might be missing
        if (profileId) {
            console.log("Matching Profile ID:", profileId, "with Clinic ID:", clinicId);
        }

        // Only use the templates if the profile matches our current clinicId OR if we have no ID yet
        if (!profileId || String(profileId) === String(clinicId)) {
            if (Array.isArray(profile?.prescriptionTemplate)) {
                clinicProfileTemplates = profile.prescriptionTemplate;
            } else if (Array.isArray(profile?.profile?.prescriptionTemplate)) {
                clinicProfileTemplates = profile.profile.prescriptionTemplate;
            } else if (Array.isArray(profile?.[0]?.prescriptionTemplate)) {
                clinicProfileTemplates = profile[0].prescriptionTemplate;
            }
        }

        const DEFAULT_TEMPLATES = [
            { title: 'Tooth Ache', text: 'Tab. Paracetamol 500mg - 1-0-1 for 3 days\nTab. Amoxicillin 500mg - 1-1-1 for 5 days\nWarm saline gargles 3-4 times a day', type: 'prescription', id: 'default-1' },
            { title: 'Fever', text: 'Tab. Paracetamol 650mg - 1-0-1 if fever > 100 F\nDrink plenty of fluids\nRest for 2 days', type: 'prescription', id: 'default-2' },
            { title: 'Common Cold', text: 'Tab. Cetirizine 10mg - 0-0-1 for 5 days\nSteam inhalation twice a day\nAvoid cold drinks', type: 'prescription', id: 'default-3' }
        ];

        return [...DEFAULT_TEMPLATES, ...templatesArray, ...clinicProfileTemplates];
    }, [TemplateData, ClinicProfileData]);

    const Templates = useMemo(() => {
        return allTemplates
            .filter((template) => {
                const type = template.type?.toLowerCase();
                return !type || type === "prescription";
            })
            .map((template) => ({
                label: template.title || template.label || "Untitled",
                value: template.id || template._id || template.title || template.label,
            }));
    }, [allTemplates]);

    const handleSubmit = async (values, { resetForm }) => {
        const now = dayjs();

        const formattedDate = now.format('YYYY-MM-DD');
        const formattedTime = now.format('HH:mm');

        try {
            const prescriptionData = {
                notes: values.notes,
                diagnosis: values.diagnosis,
                date: formattedDate,
                time: formattedTime,
                patientView: "off",
                recordType: 'prescription',
                tokenappointment: appointmentId,
                patient: PatientId,
                user,
            }
            console.log("isTemplateSaved:", isTemplateSaved);


            const response = await new Promise((resolve, reject) => {
                dispatch(postMedicalRecordsRequest(prescriptionData, resolve, reject));
            });
            toast.success(response.message);
            console.log("prescription added successfully", response);


            if (response?.medicalRecord?.id && fetchPrescription) {
                fetchPrescription();
            }
            if (isTemplateSaved) {
                const templateData = {
                    title: values.title,
                    text: values.notes,
                    type: 'prescription',
                    clinic: clinicId,
                }

                const response2 = await new Promise((resolve, reject) => {
                    dispatch(postTemplateRequest(templateData, resolve, reject));
                });

                toast.success(response2.message);
                console.log("postTemplateRequest response:", response2);
            }
            onClose();
            resetForm();

        }
        catch (error) {
            console.log(error.message || 'Failed to add notes', { variant: 'error' });
        }

    }

    return (
        <>
            <Formik
                initialValues={{
                    notes: '',
                    diagnosis: '',
                    title: '',
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
                    <Form>
                        <HeaderPart>
                            Add Prescription
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component4>
                                <Texts>Prescription Template</Texts>
                                <InputSelect
                                    value={selectValue}
                                    options={Templates}
                                    onChange={(value) => {
                                        setSelectValue(value);
                                        const selectedTemplate = allTemplates.find(template => 
                                            (template.id || template._id || template.title || template.label) === value
                                        );
                                        setFieldValue("notes", selectedTemplate ? (selectedTemplate.text || selectedTemplate.notes || "") : "");
                                    }
                                    }
                                    showNone={false}
                                    variant="outlined"
                                    placeholder="Choose"
                                    sx={{
                                        // width: '200px',
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                            borderRadius: '12px',
                                        },
                                    }}
                                />

                            </Component4>
                            <Component4>
                                <Texts>Diagnosis</Texts>
                                <InputComponent
                                    name="diagnosis"
                                    value={values.diagnosis}
                                    variant="outlined"
                                    placeholder="Enter Diagnosis"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.diagnosis && Boolean(errors.diagnosis)}
                                    helperText={touched.diagnosis && errors.diagnosis}
                                    fullWidth
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            padding: '10px 18px',
                                            borderRadius: '12px',
                                            height: '52px',
                                        },
                                    }}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Prescription</Texts>
                                <InputComponent
                                    name="notes"
                                    value={values.notes}
                                    variant="outlined"
                                    placeholder="Enter"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.notes && Boolean(errors.notes)}
                                    helperText={touched.notes && errors.notes}
                                    fullWidth
                                    multiline
                                    rows={4}
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            padding: '16px 18px',
                                            borderRadius: '12px',
                                            height: '120px',
                                        },
                                    }}
                                />
                            </Component4>
                            <Component5>
                                <InnerComponent sx={{ width: '141px' }}>
                                    <Texts>Save as ?</Texts>
                                    <PatientViewContainer>
                                        <Text>No</Text>
                                        <Switch>
                                            <SwitchComponent
                                                sx={{ marginTop: 0 }}
                                                checked={isTemplateSaved}
                                                onChange={(e) => setIsTemplateSaved(e?.target?.checked ?? !isTemplateSaved)}
                                            />
                                        </Switch>
                                        <Text>Yes</Text>

                                    </PatientViewContainer>
                                </InnerComponent>
                                {isTemplateSaved &&
                                    <InnerComponent sx={{ width: '267px' }}>
                                        <Texts>New Template Name</Texts>
                                        <InputComponent
                                            name="title"
                                            value={values.title}
                                            variant="outlined"
                                            placeholder="Enter "
                                            fullWidth
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched.title && Boolean(errors.title)}
                                            helperText={touched.title && errors.title}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '10px 18px',
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                    // border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                },
                                            }}
                                        />

                                    </InnerComponent>
                                }
                            </Component5>

                        </AddContainer>
                        <FooterPart >
                            <CancelButton
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={onClose}
                            >
                                Cancel
                            </CancelButton>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}
                                sx={{
                                    width: '104px',
                                    height: '52px',
                                    borderRadius: '12px',
                                    padding: '10px 18px',
                                    bgcolor: palette.primary.main,
                                    boxShadow: shadows[1],
                                    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                    color: palette.gery.white,
                                    '&:hover': { color: palette.primary.main },
                                }}
                            // onClick={handleSubmit ? () => handleSubmit() : null}
                            >
                                Save
                            </SaveButton>
                        </FooterPart>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default PrescriptionTabForm
